import { render, staticRenderFns } from "./PunchClock.vue?vue&type=template&id=07501522&scoped=true"
import script from "./PunchClock.vue?vue&type=script&lang=js"
export * from "./PunchClock.vue?vue&type=script&lang=js"
import style0 from "./PunchClock.vue?vue&type=style&index=0&id=07501522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07501522",
  null
  
)

export default component.exports